import calendarEvent from './calendarEvent';

export default {
  calendarEvent,
};
